import React, { useEffect } from 'react'
import Template1 from './EmailAuthTemplate/Template1'
import Template2 from './EmailAuthTemplate/Template2';
import config from '../../../config';
import Template3 from './EmailAuthTemplate/Template3';
import Template4 from './EmailAuthTemplate/Template4';
import Template5 from './EmailAuthTemplate/Template5';
import { toJS } from '../../../containers/to-js';
import { connect } from 'react-redux';
import { getCustomIcons } from '../../../actions/company';
import Template6 from './EmailAuthTemplate/Template6';

// export default function EmailAuth(props) {
class EmailAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: -1
    }
  }
  render() {
    const { itemProperties, companyDetails } = this.props;

    const template =
      itemProperties &&
      itemProperties.authTemplate && itemProperties.authTemplate.value;
    const logoUrl = companyDetails && companyDetails.data && companyDetails.data.logoUrl;
    const logoUrlComplete = `${config.assetsBasePath}${logoUrl}`


    const authTemplateSideImage = itemProperties && itemProperties.authTemplateSideImage && itemProperties.authTemplateSideImage.path
    const authTemplateSideImageUrlComplete = `${config.assetsBasePath}${authTemplateSideImage}`
    const authTemplateBackgroundColor = itemProperties && itemProperties.authTemplateBackgroundColor
    const authTemplateTopFormText = itemProperties && itemProperties.authTemplateTopFormText
    const authTemplateFontColor = itemProperties && itemProperties.authTemplateFontColor


    if (template === 'Template2') {
      return <Template2 logoUrlComplete={logoUrlComplete} authTemplateTopFormText={authTemplateTopFormText} authTemplateFontColor={authTemplateFontColor} authTemplateBackgroundColor={authTemplateBackgroundColor} authTemplateSideImageUrlComplete={authTemplateSideImageUrlComplete} {...this.props} />
    }


    if (template === 'Template3') {
      return <Template3 logoUrlComplete={logoUrlComplete} authTemplateTopFormText={authTemplateTopFormText} authTemplateFontColor={authTemplateFontColor} authTemplateBackgroundColor={authTemplateBackgroundColor} authTemplateSideImageUrlComplete={authTemplateSideImageUrlComplete} {...this.props} />
    }

    if (template === 'Template4') {
      return <Template4 logoUrlComplete={logoUrlComplete} authTemplateFontColor={authTemplateFontColor} authTemplateSideImageUrlComplete={authTemplateSideImageUrlComplete} authTemplateBackgroundColor={authTemplateBackgroundColor} authTemplateTopFormText={authTemplateTopFormText}  {...this.props} />
    }
    if (template === 'Template5') {
      return <Template5 logoUrlComplete={logoUrlComplete} authTemplateFontColor={authTemplateFontColor} authTemplateSideImageUrlComplete={authTemplateSideImageUrlComplete} authTemplateBackgroundColor={authTemplateBackgroundColor} authTemplateTopFormText={authTemplateTopFormText}  {...this.props} />
    }

       if (template === 'Template6') {
      return <Template6 logoUrlComplete={logoUrlComplete} authTemplateFontColor={authTemplateFontColor} authTemplateSideImageUrlComplete={authTemplateSideImageUrlComplete} authTemplateBackgroundColor={authTemplateBackgroundColor} authTemplateTopFormText={authTemplateTopFormText}  {...this.props} />
    }


    return (
      <Template1 authTemplateTopFormText={authTemplateTopFormText} {...this.props} />
    )
  }
}


const mapStateToProps = (state) => {
  const locale = state.get('locale');
  const companySettings = state.getIn(['company', 'details', 'data', 'companySettings']);
  return {
    customIcons: state.getIn(['company', 'icons']),
  };
};


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getCustomIcons: payload => {
      dispatch(getCustomIcons(payload));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(EmailAuth));